import { allowedDecisioningCreativeComponentNames } from "./constants";
import type { DecisioningCreativeComponentName } from "./types";

export const isDecisioningCreativeComponentName = (
  componentName: string
): componentName is DecisioningCreativeComponentName => {
  return (allowedDecisioningCreativeComponentNames as readonly string[]).includes(componentName);
};
